export default __webpack_public_path__ + "static/media/home-city-outline.0489fb75.svg";